import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import ReportTable from './table/ReportTable';
import { viewingReport } from '../../store/reports/selectors';
import trainingPhasesActions from '../../store/training-phases/action-creators';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import usersActionCreators from "../../store/users/action-creators";
import ModalSplit from "../../../shared/ui/ModalSplit";
import ReportViewSplit from "./ReportViewSplit";
import ReportEditSplit from "./ReportEditSplit";

class ReportIndex extends Component {
  // ----------------------
  // Computed
  // ----------------------

  constructor(props) {
    super(props);

    this.props.fetchUsers();
  }

  get isLoading() {
    return !this.props.reports;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {!this.isLoading && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">Reports </h4>
              </div>
              <div className="app-content">
                {!this.props.reports ? (
                  <div className="alert alert-primary" role="alert">
                    No Reports found
                  </div>
                ) : (
                  <ReportTable
                    reports={this.props.reports}
                    users={this.props.users}
                  />
                )}
              </div>
              <ModalSplit
                isOpen={this.props.isViewingReportModalOpened}
                onClose={() => this.props.closeViewReport()}
                title={this.props.report && this.props.report.formName}
                fullscreen={true}
              >
                 <ReportViewSplit report={this.props.report}/>
              </ModalSplit>
              <ModalSplit
                isOpen={this.props.isEditingReportModalOpened}
                onClose={() => this.props.closeEditReport()}
                title={
                  this.props.editingReport && this.props.editingReport.formName
                }
              >
                <ReportEditSplit/>
              </ModalSplit>
            </Fragment>
          )}
        </Fragment>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    reports: state.reports.openReportList,
    report: viewingReport(state),
    users: state.users.usersByMaster,
    isViewingReportModalOpened: state.trainingPhases.isViewingReportModalOpened,
    isEditingReportModalOpened: state.trainingPhases.isEditingReportModalOpened,
    editingReport: trainingPhasesSelectors.editingReport(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeViewReport: () => {
      dispatch(trainingPhasesActions.closeViewReport());
    },
    closeEditReport: () => {
      dispatch(trainingPhasesActions.closeEditReport());
    },
    fetchUsers: () => dispatch(usersActionCreators.fetchUsersByMaster())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportIndex);
